import { render, staticRenderFns } from "./SwUpdateAlert.vue?vue&type=template&id=cf336d36&"
import script from "./SwUpdateAlert.ts?vue&type=script&lang=ts&"
export * from "./SwUpdateAlert.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports